import React, { useEffect, useState } from "react";
import { useAuth } from "../../auth/FirebaseAuth";
import { db } from "../../config/FirebaseConfig";
import { useAppContext } from "../../config/AppContext";
import {
  getArrayDocDataByRef,
  queryCollection,
} from "../../models/DataFunctions";
import { transformCarnetsToTable } from "../../models/OrgFunctions";
import { useSnackbar } from "notistack";
import { doc } from "firebase/firestore";
import updateDocDataFieldApi from "../../api/database/updateDocDataFieldApi";
import { Spin } from "antd";
import Modal1 from "../../modals/Modal1";
import Tag from "../../tag/Tag";
import TagFilter from "../../tag/TagFilter";
import Tippy from "@tippyjs/react";
import SearchBarCarnets from "../../textfields/SearchBarCarnets";
import DataGridGPT2 from "../../tables/DataGridGPT2";
import DropDownGPT1 from "../../dropdowns/DropDownGPT1";
import TabGPT from "../../tabs/TabGPT";
import PrimaryButton from "../../buttons/PrimaryButton";
import Icon1 from "../../icons/Icon";
import Space from "../../layout/Space";
import { User } from "../../types/user";
import { Org, Workspace } from "../../types/org";
import SmallSpinner from "../../loading/SmallSpinner";
import { se } from "date-fns/locale";

interface CarnetsProps {
  userData: User;
  orgData: Org;
  overrideId?: string;
  navigateWorkspace: (path: string) => void;
  workspaceData?: Workspace;
}

function Carnets({
  userData,
  orgData,
  overrideId,
  navigateWorkspace,

  workspaceData,
}: CarnetsProps) {
  const { currentUser, loading } = useAuth();
  const [tag_open, setTagOpen] = useState(false);
  const { appState, setAppState, fetchCarnets, filter } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const folders_config = appState.folders_config;
  const saved_data = appState.saved_data;

  const [searchValue, setSearchValue] = useState("");
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  interface OptionItem {
    label: string;
    value: any;
    extra_label?: string;
  }
  const [options, setOptions] = useState<OptionItem[]>([]);
  const [year, setYear] = useState(null);
  const [loadingRows, setLoadingRows] = useState(true);
  const handleSetSeachValue = (value: any) => {
    setSearchValue(value);
    console.log("searchValue", value);
  };

  const handleSetsearchCarnets = (value: any) => {
    setsearchCarnets(value);
    let new_folders_config = folders_config || {};
    new_folders_config.search_folders = value;
    // set folders_config
    setAppState((prevState: any) => ({
      ...prevState,
      folders_config: new_folders_config,
    }));
  };

  const years = [
    { value: 2024, label: "2024" },
    { value: 2025, label: "2025" },
  ];

  const [tag_folder_id, setTagFolderId] = useState(null);
  const [tag_index, setTagIndex] = useState(1);
  // Function to navigate to a client by ID
  const gotoFolder = (id: any) => {
    navigateWorkspace(`/carnet/${id.id}`);
  };

  const gotoNewFolder = () => {
    if (orgData.type !== "master") {
      navigateWorkspace(`/newcarnet`);
    } else {
      navigateWorkspace(`/newcarnet`);
    }
  };

  const handleOpenTag = (folderid: any, index: any) => {
    setTagOpen(true);
    setTagIndex(index);
    setTagFolderId(folderid);
  };

  // Function to navigate to a client by name
  const gotoFolderName = (option: any) => {
    handleSearchChange(option.label);
    // Find the client with the matching name
  };

  const handleFiltersTagChange = async (filters: any) => {
    let new_folders_config = folders_config || {};
    new_folders_config.tags_filters = filters;
    // set folders_config
    setAppState((prevState: any) => ({
      ...prevState,
      folders_config: new_folders_config,
    }));
  };
  const [update_search, setUpdateSearch] = useState(false);
  const handleSearchChange = async (name: any) => {
    handleSetSeachValue(name);
    setUpdateSearch(true);
  };

  const [tabs, setTabs] = useState([
    { label: "Interventions à venir", id: "upcoming" },
    { label: "Interventions réalisées", id: "completed" },
    { label: "Dossiers archivés", id: "archived" },
  ]);

  const [allcarnets, setAllCarnets] = useState<any[]>([]);
  const tabContent = [<span></span>, <span></span>, <span></span>];
  const [particulier_folders, setParticulierFolders] = useState([]);

  const [masters, setMasters] = useState([]);
  const [only_folder_filter, setOnlyFolderFilter] = useState(
    folders_config?.only_folder_filter || null
  );

  const [activetab, setactivetab] = useState("current");
  const [clients, setClients] = useState([]);
  const [partners, setPartners] = useState([]);

  const [searchCarnets, setsearchCarnets] = useState(
    folders_config?.search_folders || "folders"
  );
  const [tagFilterOpen, setTagFilterOpen] = useState(false);
  const [tag_filters, setTagFilters] = useState([]);

  const [users, setUsers] = useState([]);

  const handleTabChange = async (newTab: any) => {
    let new_folders_config = folders_config || {};
    new_folders_config.tab = newTab;
    // set folders_config
    setAppState((prevState: any) => ({
      ...prevState,
      folders_config: new_folders_config,
    }));

    setactivetab(newTab);
  };

  // Function to fetch data for the current user
  const handleFetchData = async (tab = null) => {
    if (userData) {
      // Fetch user data by currentUser's ID

      let carnets = await fetchCarnets(orgData);
      setAllCarnets(carnets);

      setOptions(
        carnets.map((carnet: any) => ({
          label: carnet.name,
          value: carnet.id,

          extra_label: carnet.city,
        }))
      );

      setTabs([
        {
          label: "Carnets en cours",
          id: "current",
        },

        {
          label: "Carnets archivés",
          id: "archived",
        },
      ]);

      setTimeout(() => {
        setLoadingRows(false);
      }, 100);
      // Set options for the search bar (client names)
      let end_time = new Date().getTime();
    }
  };

  useEffect(() => {
    if (orgData) {
      const { rows, columns } = transformCarnetsToTable(
        allcarnets,
        activetab,
        orgData,
        userData,
        handleOpenTag,
        searchValue,
        year,
        searchCarnets
      );
      let sorted_rows = rows.sort((a, b) => {
        return a.name.trim().localeCompare(b.name.trim());
      });
      setRows((sorted_rows as any) || []);
      setColumns((columns as any) || []);
      setUpdateSearch(false);
    }
  }, [
    allcarnets,
    orgData,
    userData,
    update_search,
    year,
    searchCarnets,
    searchValue,
    activetab,
  ]);

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (
    message: string,
    variant: "success" | "error" | "default" | "warning" | "info" | undefined
  ) => {
    enqueueSnackbar(message, { variant });
  };

  const handleSetTag = async (tag_nom: any, carnet_id: any) => {
    let carnet: any = allcarnets.find((carnet: any) => carnet.id === carnet_id);
    if (!carnet) {
      console.error("Carnet not found");
      return;
    }
    const carnetRef = doc(db, "carnet", carnet_id);
    const carnet_tags = carnet.tags?.concat(carnet.tags2) || [];
    const my_tags = carnet_tags?.filter(
      (tag: any) => tag?.org_id === orgData.id
    );
    const my_tag = my_tags[tag_index];

    const carnet_tags_removed = carnet_tags.filter(
      (tag: any) =>
        tag != undefined &&
        (tag?.nom !== my_tag?.nom || tag?.org_id !== my_tag?.org_id)
    );
    let new_tag = my_tag;
    if (tag_nom == "pas de tag") {
      new_tag = null;
    } else if (tag_nom == "#nouveau") {
      new_tag = {
        nom: "#nouveau",
        org_id: orgData.id,
        colorint: -2494209,
      };
    } else {
      const org_tag = orgData.tags.find((tag: any) => tag?.nom === tag_nom);
      new_tag = {
        nom: org_tag?.nom,
        org_id: orgData.id,
        colorint: org_tag.colorint,
      };
    }

    let new_carnet_tags : any[] = [];
    if (new_tag) {
      new_carnet_tags = [...carnet_tags_removed, new_tag];
    } else {
      new_carnet_tags = carnet_tags_removed;
    }

    await updateDocDataFieldApi(carnetRef, "tags", new_carnet_tags, prefix);
    await updateDocDataFieldApi(carnetRef, "tags2", [], prefix);
    setAllCarnets((prev: any) => {
      const other_carnets = prev.filter((c: any) => c.id !== carnet.id);
      return [...other_carnets, { ...carnet, tags: new_carnet_tags, tags2: [] }];
    });
    handleClickVariant("Tag ajouté", "success");
    setTagOpen(false);
  };

  const [loadingSelection, setLoadingSelection] = useState("");

  const handleSortChange = (sortModel: any) => {
    if (sortModel.length > 0) {
      const { field, sort } = sortModel[0]; // Get the field and sort direction
      let new_folders_config = folders_config || {};
      new_folders_config.field = field;
      new_folders_config.sort = sort;
      // set folders_config
      setAppState((prevState: any) => ({
        ...prevState,
        folders_config: new_folders_config,
      }));
      // You can add additional logic here, such as updating state or making an API call
    } else {
    }
  };

  const handleSetSearchType = async (type: any) => {
    let newsearchCarnets = type;
    handleSetsearchCarnets(newsearchCarnets);

    setOptions(
      allcarnets.map((carnet: any) => ({
        label: carnet.nom,
        value: carnet.id,
        extra_label: carnet.city,
      }))
    );
  };

  useEffect(() => {
    if (saved_data && saved_data.folders) {
      handleFetchData();
    } else {
      if (userData) {
        handleFetchData();
      }
    }
  }, [saved_data, userData]);

  if (loading || !currentUser || !userData || loadingRows) {
    return (
      <div className="h-full w-full pl-4 mr-4 flex flex-col items-center justify-center gap-2">
        <SmallSpinner />
      </div>
    );
  }

  // Render the client data
  return (
    <div className="flex flex-col h-full w-full pl-4">
      <Modal1
        isOpen={tag_open}
        onClose={() => {
          setTagOpen(false);
        }}
      >
        <Tag
          tag_folder_id={tag_folder_id}
          orgData={orgData}
          handleSetTag={handleSetTag}
        ></Tag>
      </Modal1>
      <Modal1
        isOpen={tagFilterOpen}
        onClose={() => {
          setTagFilterOpen(false);
        }}
      >
        <TagFilter
          orgData={orgData}
          setTagFilters={handleFiltersTagChange}
          onClose={() => setTagFilterOpen(false)}
          folders_config={folders_config}
          navigateWorkspace={navigateWorkspace}
        ></TagFilter>
      </Modal1>
      <div className="flex flex-row w-full h-full  ">
        <div className="flex flex-col gap-2 h-full w-full max-h-full overflow-auto ">
          <div className="flex flex-row gap-1 ">
            <div className="text-hx font-medium">Carnets</div>{" "}
          </div>
          <div className="flex  gap-2 flex-row max-w-c1p2k 2xl:justify-between h-fit">
            {/* Search Bar */}
            <SearchBarCarnets
              orgData={orgData}
              options={options}
              setValue={handleSetSeachValue}
              value={searchValue}
              onAction={gotoFolderName}
              setSeachType={handleSetSearchType}
            />
            <div className="flex flex-row gap-2 mr-2 ml-auto">
              {!workspaceData && orgData?.logement?.access?.can_create === true && (
                <PrimaryButton onClick={gotoNewFolder}>
                  <div className="flex flex-row content-center items-center ">
                    <Icon1
                      icon_name="plus"
                      height="16px"
                      width="16px"
                      fill="white"
                    ></Icon1>
                    <Space x={5} />
                    Nouveau Carnet
                  </div>
                </PrimaryButton>
              )}
            </div>{" "}
          </div>
          {searchValue === "" && (
            <div className="flex flex-row gap-2">
              <div className="ml-0 pl-0 left-0 relative">
                <TabGPT
                  tabs={tabs}
                  activeTab={activetab}
                  setActiveTab={handleTabChange}
                />
              </div>{" "}
            </div>
          )}

          {/* DataGrid displaying the clients */}
          <div className="w-full h-full max-w-c1p2k overflow-y-auto">
            <div
              className={`h-full ${
                overrideId ? "max-h-[70vh]" : "pb-10"
              }  min-h-6`}
            >
              <DataGridGPT2
                is_folders={true}
                selectable={false}
                rows={rows}
                columns={columns}
                searchValue={searchValue || ""}
                onClick={(e: any) => gotoFolder(e)}
                initial_asc={"asc"}
                handleSortChange={handleSortChange}
                initialPage={0}
                initialPageSize={100}
                orgData={orgData}
              ></DataGridGPT2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Carnets;
